export function mergeCanonicalEntry(localEntry, completion, fallback = {}) {
  const local = localEntry || {};
  return {
    ...local,
    ...completion,
    poolWords: local.poolWords?.length ? local.poolWords : fallback.poolWords || [],
    letters: local.letters?.length ? local.letters : fallback.letters || [],
    validRows: completion.validRows ?? local.validRows ?? 0,
    attemptId: completion.attemptId || local.attemptId || null,
    syncStatus: "synced",
    syncError: null
  };
}

export function remoteCompletionAction(openGame, completion) {
  if (
    !openGame
    || openGame.date !== completion.date
    || openGame.difficulty !== completion.difficulty
    || (openGame.attemptId && openGame.attemptId === completion.attemptId)
  ) return "ignore";
  if (openGame.submitted) return "replace";
  return openGame.cursor === 0 ? "replace" : "defer";
}

export function pendingCompletionEntries(history, range = {}) {
  const { from = "0000-01-01", to = "9999-12-31" } = range;
  return Object.values(history || {})
    .flatMap((dateEntries) => Object.values(dateEntries || {}))
    .filter((entry) => (
      entry.syncStatus === "pending"
      && entry.date >= from
      && entry.date <= to
    ));
}

export function shouldRetryCompletion(entry) {
  return entry?.syncStatus === "pending";
}

export function isSyncFresh(lastSuccess, now, maxAge) {
  return Number(lastSuccess) > 0 && now - Number(lastSuccess) < maxAge;
}

export async function settleWithin(promise, milliseconds, timers = globalThis) {
  let timeoutId;
  const timeout = new Promise((resolve) => {
    timeoutId = timers.setTimeout(() => resolve({ status: "timeout" }), milliseconds);
  });
  const result = await Promise.race([promise, timeout]);
  timers.clearTimeout(timeoutId);
  return result;
}
